import {Component, ElementRef, Input, Self, ViewChild} from "@angular/core";
import {AbstractControl, ControlValueAccessor, NgControl} from "@angular/forms";

let NEXT_ID = 0;

@Component({
    selector: "valg-input-file",
    templateUrl: "./input-file.component.html",
})
export class InputFileComponent implements ControlValueAccessor {
    @Input() errorKey?: string
    @Input() placeholder: string = "placeholder"
    id = `valg-input-file-${NEXT_ID++}`;

    constructor(@Self() private readonly ngControl: NgControl) {
        ngControl.valueAccessor = this;
    }

    get formControl() {
        return this.ngControl;
    }

    @ViewChild("input") inputElementRef!: ElementRef<HTMLInputElement>

    file: File | undefined;
    private onChange!: (value?: File) => void;
    private onTouched!: () => void;

    writeValue(obj: File): void {
        this.file = obj;
    }

    registerOnChange(fn: (value?: File) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    onClick() {
        this.inputElementRef.nativeElement.click()
        this.onTouched();
    }

    onInputChange() {
        this.file = this.inputElementRef.nativeElement.files?.[0]
        this.onChange(this.file)
    }

    public static CreateFileFormatOrSizeValidator(fileTypes: string[], maxFileSize: number = 0) {
        return (control: AbstractControl) => {
            if (control.value) {
                const file = (control.value as File)
                return fileTypes.includes(file.type) && (maxFileSize == 0 || maxFileSize > file.size) ?
                null :
                {invalid_file_format: true};
            }
            return null;
        };
    }

    onReset()
    {
        this.inputElementRef.nativeElement.value = '';
    }
}
